import { EJRecordTypes } from 'src/common/enumerations/ej-record-types';
import { EntryMethod } from 'src/common/enumerations/entry-method';
import { IItemInputData } from 'src/common/interfaces/IItemInputData';
import { IElectronicJournalRecord } from 'src/common/interfaces/states/IElectronicJournalRecord';
import { addLineItemToTransaction } from 'src/home-page/business-logic/sale-mode-router';
import { CartItemViewData } from 'src/items-list/business-logic/service/interfaces/cart-response';
import { LineItemAddDto } from 'src/items-list/business-logic/service/interfaces/line-item-add.dto';
import { store } from '../../common/redux/configure-store';
import { getLineItem } from '../../items-list/business-logic/line-item-builder';
import { popupMessage } from '../../messages/business-logic/popup-message';

export const handleRepeat = async (): Promise<void> => {
  const { itemList } = store.getState();

  const productEjItems: IElectronicJournalRecord[] = itemList.ejItems.filter(
    i => i.Type === EJRecordTypes.Product,
  );
  const item: IElectronicJournalRecord = productEjItems[productEjItems.length - 1];
  const rawItem: CartItemViewData | undefined = itemList.items?.find(
    rItem => item.SequenceNumber === rItem.lineId,
  );

  const inputData: IItemInputData = {
    itemId: item.ItemId,
    entryMethod: EntryMethod.Repeat,
    quantity: item.Quantity,
    quantityEntryMethod: rawItem?.lineItem?.quantity?.entryMethod as EntryMethod,
    isManualWeight: false,
  };

  const lineItem: LineItemAddDto = getLineItem(inputData);
  lineItem.sequenceNumber = item.SequenceNumber;
  lineItem.modifiers = rawItem?.lineModifiers;
  lineItem.newPrice = rawItem?.amount;
  lineItem.isDepartment = rawItem?.lineItem?.itemId?.type === 'POSDepartment';
  lineItem.withData = false;

  return addLineItemToTransaction({ lineItem, inputData, itemLookup: {} }).catch(popupMessage);
};
